import React, { FC } from 'react';

import { TEXTS } from 'application/pages/BillingPage/renderer/texts';

import Button, { ButtonType } from '@zvuk-b2b/react-uikit/ui/Button';

interface BindCardButtonProps {
  visible: boolean;
  isLoading: boolean;
  onClick: () => void;
}

const BindCardButton: FC<BindCardButtonProps> = ({ visible, isLoading, onClick }) =>
  visible ? (
    <Button
      elementId="button_bind_card"
      type={ButtonType.PRIMARY}
      isLoading={isLoading}
      onClick={onClick}>
      {TEXTS.BILLING_BIND_CARD_BUTTON_TEXT}
    </Button>
  ) : null;

export default React.memo(BindCardButton);
